import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { FiMail, FiAlertCircle, FiCheck, FiRefreshCw } from 'react-icons/fi';

const VerifyEmailPrompt = () => {
  const navigate = useNavigate();
  const [resendStatus, setResendStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleResendVerification = async () => {
    setIsLoading(true);
    setResendStatus(null);
    
    try {
      await axiosInstance.post('/auth/resend-verification');
      setResendStatus({ success: true, message: 'Verification email has been resent to your inbox!' });
    } catch (error) {
      setResendStatus({ 
        success: false, 
        message: error.response?.data?.message || 'Failed to resend verification email. Please try again later.' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-gray-800 px-4">
      <div className="p-8 bg-gray-800 border border-gray-700 rounded-lg shadow-2xl max-w-md w-full">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
            <FiMail className="text-white text-2xl" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">Verify Your Email</h1>
          
          <p className="text-gray-300 mb-8">
            We've sent a verification link to your email address. Please check your inbox and click the link to activate your account.
          </p>
          
          {resendStatus && (
            <div className={`p-4 mb-6 rounded-md w-full ${resendStatus.success ? 'bg-green-900/60 border border-green-700' : 'bg-red-900/60 border border-red-700'}`}>
              <div className="flex items-center">
                {resendStatus.success ? 
                  <FiCheck className="text-green-400 mr-2" /> : 
                  <FiAlertCircle className="text-red-400 mr-2" />
                }
                <p className={`text-sm ${resendStatus.success ? 'text-green-300' : 'text-red-300'}`}>
                  {resendStatus.message}
                </p>
              </div>
            </div>
          )}
          
          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <button
              onClick={handleResendVerification}
              disabled={isLoading}
              className={`flex-1 px-4 py-3 rounded-md flex items-center justify-center ${
                isLoading 
                  ? 'bg-gray-600 cursor-not-allowed' 
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
            >
              {isLoading ? (
                <FiRefreshCw className="animate-spin mr-2" />
              ) : (
                <FiMail className="mr-2" />
              )}
              {isLoading ? 'Sending...' : 'Resend Verification'}
            </button>
            
            <button
              onClick={() => navigate('/signin')}
              className="flex-1 px-4 py-3 border border-gray-600 text-gray-300 rounded-md hover:bg-gray-700 transition-colors"
            >
              Back to Sign In
            </button>
          </div>
          
          <p className="mt-8 text-sm text-gray-500">
            If you continue to experience issues, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPrompt; 